import apiProjects from '@/api/projects';

// サイトが切り替わったらリセットする必要がある値たち
const projectState = {
    task: {
        count: null
    },
    users: []
};

const project = {
    namespaced: true,
    state: JSON.parse(JSON.stringify(projectState)),
    getters: {
        usersName(state) {
            return state.users.reduce(
                (acc, current) =>
                    Object.assign(acc, { [current.userId]: current.name }),
                {}
            );
        },
        usersSelect(state) {
            return state.users.map(item => {
                return {
                    value: item.userId,
                    label: item.name
                };
            });
        }
    },
    mutations: {
        setTaskCount(state, payload) {
            state.task.count = payload;
        },
        setUsers(state, payload) {
            state.users = payload;
        },
        reset(state) {
            state.task.count = null;
            state.users = [];
        }
    },
    actions: {
        async getTaskCount({ commit, rootState }) {
            const count = await apiProjects.tasks.count
                .get(rootState.user.status.idToken, rootState.view.projectId)
                .then(response => response.data.todo + response.data.doing)
                .catch(error => null);
            commit('setTaskCount', count);
        },
        async getUsers({ commit, rootState }) {
            const users = await apiProjects.users
                .get(rootState.user.status.idToken, rootState.view.projectId)
                .then(response => response.data.items)
                .catch(() => []);
            commit('setUsers', users);
        },
        getGaVersion({ rootState }) {
            return apiProjects.gaVersion
                .get(rootState.user.status.idToken, rootState.view.projectId)
                .then(response => {
                    const gaVersion = Object.entries(response.data).reduce(
                        (acc, [key, value]) => {
                            return Object.assign(acc, {
                                [key]: value.toLowerCase()
                            });
                        },
                        {}
                    );
                    return gaVersion;
                });
        },
        setTaskCount({ commit }, response) {
            commit('setTaskCount', response);
        },
        setUsers({ commit }, response) {
            commit('setUsers', response);
        },
        reset({ commit }) {
            commit('reset');
        }
    }
};

export default project;
